export default {
      id: "ic-home-idees-usage",
      viewBox: "0 0 51.2 51.2",
      url: "../dist/images/" + "sprite.svg#ic-home-idees-usage",
      toString: function () {
        return this.url;
      }
    }